var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"entry-card",attrs:{"to":_vm.to}},[_vm._t("default",[_c('v-card-text',[_vm._v("\n      "+_vm._s(_vm.entry.name || _vm.entry.desc || _vm.entry.id || _vm.entry)+"\n    ")])],{"entry":_vm.entry})],2)}
var staticRenderFns = []

export { render, staticRenderFns }